import { render, staticRenderFns } from "./AvailablesPlans.vue?vue&type=template&id=2ec52d18&scoped=true&"
import script from "./AvailablesPlans.vue?vue&type=script&lang=js&"
export * from "./AvailablesPlans.vue?vue&type=script&lang=js&"
import style0 from "./AvailablesPlans.vue?vue&type=style&index=0&id=2ec52d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec52d18",
  null
  
)

export default component.exports